// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","wrapper":"Avatar-module__wrapper--EC","avatar":"Avatar-module__avatar--hl","withOutline":"Avatar-module__withOutline--b6","my":"Avatar-module__my--j1"};